<div class="swiper-container mt-50">
<!--   [swiper]="config" todo swiper-->
  <div class="swiper-wrapper mb-30">
    <div class="swiper-slide flex flex-col justify-center items-center">
      <img src="/assets/images/offers/change-biller-offer-1.svg" />
      <div class="italic mt-42 f-16 text-center">
        Ekspert porównuje i prezentuje oferty dopasowane do Twoich potrzeb.
      </div>
    </div>

    <div class="swiper-slide flex flex-col justify-center items-center">
      <img src="/assets/images/offers/change-biller-offer-2.svg" />
      <div class="italic mt-42 f-16 text-center">
        Ty wybierasz najlepszą ofertę instalacji fotowoltaicznej i oszczędzasz nawet kilka tysięcy złotych rocznie!
      </div>
    </div>
  </div>
  <div class="swiper-pagination"></div>
  <div class="swiper-button-prev">
    <app-icon name="keyboard_arrow_left"></app-icon>
  </div>
  <div class="swiper-button-next">
    <app-icon name="keyboard_arrow_right"></app-icon>
  </div>
</div>

<div class="flex flex-row items-center justify-center items-center mt-16">
  <img src="/assets/images/offers/discount.svg" class="pr-18 discount-icon" />
  <div class="f-12">
    Zajmujesz się rachunkami w domu jednorodzinnym? Chcesz oszczędzać, być eko i zdobyć niezależność? Ta oferta jest dla
    Ciebie!
  </div>
</div>

<mat-dialog-actions align="start">
  <button color="primary" mat-raised-button (click)="next()">Dalej</button>
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
